module.exports = __webpack_public_path__ + "media/components/app-store/static/s8-bc246e8cc72020954869f22067778374.jpg";